/* tslint:disable */
/* eslint-disable */
// Generated by Microsoft Kiota
// @ts-ignore
import { ByDateRequestBuilderRequestsMetadata, type ByDateRequestBuilder } from './byDate/index.js';
// @ts-ignore
import { ByIdRequestBuilderRequestsMetadata, type ByIdRequestBuilder } from './byId/index.js';
// @ts-ignore
import { type BaseRequestBuilder, type KeysToExcludeForNavigationMetadata, type NavigationMetadata } from '@microsoft/kiota-abstractions';

/**
 * Builds and executes requests for operations under /api/exports/orders
 */
export interface OrdersRequestBuilder extends BaseRequestBuilder<OrdersRequestBuilder> {
    /**
     * The byDate property
     */
    get byDate(): ByDateRequestBuilder;
    /**
     * The byId property
     */
    get byId(): ByIdRequestBuilder;
}
/**
 * Uri template for the request builder.
 */
export const OrdersRequestBuilderUriTemplate = "{+baseurl}/api/exports/orders";
/**
 * Metadata for all the navigation properties in the request builder.
 */
export const OrdersRequestBuilderNavigationMetadata: Record<Exclude<keyof OrdersRequestBuilder, KeysToExcludeForNavigationMetadata>, NavigationMetadata> = {
    byDate: {
        requestsMetadata: ByDateRequestBuilderRequestsMetadata,
    },
    byId: {
        requestsMetadata: ByIdRequestBuilderRequestsMetadata,
    },
};
/* tslint:enable */
/* eslint-enable */
